/**
 * Scroll Reducer
 */
import {SET_GO_SCROLL_TOP} from "Actions/types";

const INITIAL_STATE = {
    goScrollTop: false,
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_GO_SCROLL_TOP:
            return {...state, goScrollTop: action.payload};
        // default case
        default:
            return { ...state };
    }
}